module.exports = __webpack_public_path__ + "img/swiper1.e9efa2af.jpg";